<template>
    <div class="main"> 
        <!-- style="margin-bottom: 16vw"  v-if="divShow"-->
        <div class="imgDiv">
            <img :src="$OSS+'imgText02_01.png'" alt="">
            <img :src="$OSS+'imgText02_02.jpg'" alt="">
            <img :src="$OSS+'imgText02_03.jpg'" alt="">
            <img :src="$OSS+'imgText02_04.jpg'" alt="">
            <img :src="$OSS+'imgText02_05.jpg'" alt="">
            <!-- <div></div> -->
        </div>
        <div class="imgBtn" @click="jump_router"> 
            <img :src="$OSS+'nowOrder.png'" alt="">
        </div>

        <Popup
            v-model="popup_show"
            position="top"
            overlay-class="popup_box"
            @close="popup_close"
            :close-on-click-overlay="true"
            :lock-scroll="true"
            :lazy-render="false"
        >
            <img class="WXTExtension_popup" :src="popup_img" />
        </Popup>
    </div>
</template>

<script>
import { Popup } from "vant";
import { URL5 } from "@/utils/Redirect";
import { mapState } from "vuex";
export default {
    components:{Popup},
    computed: {
        ...mapState({
            scrollValue: (state) => {
                return state.Public.scrollValue;
            },
        }),
    },
    data() {
       return {
        popup_show: null, //微信打开的遮罩
        popup_img: '',
       } 
    },
    mounted() {
        // setTimeout(()=>{
        //     this.divShow = true
        // },0)
    },
    methods: {
        jump_router() {
            if (this.$config.WebOS == "wx") {
                this.popup_show = true;
                if (!window.location.hash.includes("jump_link=1")) {
                history.replaceState({}, 0, window.location.href + "?jump_link=1");
                }
                if (this.$config.SystemOS == "IOS") {
                this.popup_img = this.$OSS + "renew_tips_ios.png";
                } else {
                this.popup_img = this.$OSS + "renew_tips_android.png";
                }
            } else {
                window.open(URL5);
            }
        },
        popup_close() {
            if (window.location.hash.includes("jump_link=1")) {
                history.replaceState(
                {},
                0,
                window.location.href.replace("?jump_link=1", "")
                );
            }
        }
    }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>